import classNames from "classnames";
import { percentageSignFilter, tinyFractionApproximationFilter } from "app/filters/ngFilters";
import type { FC } from "react";
import type { ITableCellProps } from "../interfaces/ITableCellProps";
import { WinnerIcon } from "./LeaderDefaultCell";

export const LeaderSearchCell: FC<ITableCellProps> = ({ value }) => {
    const realValue = value["Value"],
        isLeader = value["IsLeader"],
        classes = classNames("u-flex-row value", isLeader ? "value--leader" : "no-leader-icon-offset");

    return (
        <div className="leader-cell">
            {realValue === 0 ? (
                <span className={classes}>N/A</span>
            ) : (
                <span className={classes}>
                    {isLeader ? <WinnerIcon iconName="winner" /> : null}
                    {tinyFractionApproximationFilter()(percentageSignFilter()(realValue, 2), 0.01)}
                </span>
            )}
        </div>
    );
};
LeaderSearchCell.displayName = "LeaderSearchCell";
